<mat-tree #tree 
          [treeControl]="treeControl"  
          [dataSource]="dataSource" 
          class="transparent"
>

  <mat-tree-node 
    *matTreeNodeDef="let node" 
    [matTreeNodePadding]="node.level" 
    [matTreeNodePaddingIndent]="0"
    class="flex-row flex--align-center min-height-none"
    [ngClass]="{
      selected:getTreeItemUrl(node) === (routeSubject | async)
    }"
  >

    <button  
        [routerLink]="node.routeTo" 
        (click)="handleReroute(node)"
        mat-button 
        [ngStyle]="{
          'padding-left':(node.level*28 + 8)+'px'
        }"
        [ngClass]="{
          'light-bold':getTreeItemUrl(node) === (routeSubject | async)
        }"    
        class="link-button full-width primary-contrast-text"
    >
      <mat-icon class="primary" *ngIf="node.icon">{{node.icon}}</mat-icon>
      {{node.text | translate}}
    </button>
  </mat-tree-node>

  <mat-nested-tree-node 
      *matTreeNodeDef="let node;when:hasChild"    
      class="display-block min-height-none"
  >
      <div  class="flex-row flex--align-center gap-none icon-btn-height "  
            [matTreeNodePadding]="node.level" 
            [matTreeNodePaddingIndent]="0"    
            [ngClass]="{
              selected:getTreeItemUrl(node) === (routeSubject | async)
            }"
      >
        <button mat-button
                class="link-button full-width  flex-1 border-radius-none primary-contrast-text " 
                matTreeNodeToggle
                [ngStyle]="{
                  'padding-left':(node.level*28 + 8)+'px'
                }"
        >
              <mat-icon  class="rotate-animation"   [ngStyle]="{rotate:treeControl.isExpanded(node) ? '90deg':undefined}">
                chevron_right
              </mat-icon>
              {{node.text | translate}}
        </button>  
        
      </div>
    
    
    

    <div [ngStyle]="{
            height:treeControl.isExpanded(node) ? 'auto' : '0rem'
          }"
    >
      <div *ngIf="treeControl.isExpanded(node)" matTreeNodeOutlet></div>
    </div>

  </mat-nested-tree-node>

</mat-tree>
